const icons = {
    'arrow-right': '"\\e906"',
    basket: '"\\e919"',
    'calendar-from': '"\\e900"',
    'calendar-to': '"\\e901"',
    chat: '"\\e924"',
    'chevron-down': '"\\e907"',
    'chevron-left': '"\\e908"',
    'chevron-right': '"\\e909"',
    'chevron-up': '"\\e90a"',
    clock: '"\\e902"',
    coins: '"\\e926"',
    cross: '"\\e90b"',
    crown: '"\\e90c"',
    extras: '"\\e92e"',
    facebook: '"\\e912"',
    family: '"\\e903"',
    feet: '"\\e918"',
    gift: '"\\e920"',
    home: '"\\e904"',
    instagram: '"\\e921"',
    linkedin: '"\\e923"',
    mail: '"\\e914"',
    'mail-filled': '"\\e91b"',
    messenger: '"\\e91c"',
    min: '"\\e91e"',
    'moon-and-stars': '"\\e905"',
    phone: '"\\e925"',
    plus: '"\\e91f"',
    question: '"\\e91d"',
    'rotate-left': '"\\e916"',
    'rotate-right': '"\\e917"',
    search: '"\\e91a"',
    twitter: '"\\e913"',
    controls: '"\\e92e"',
    'video-fullscreen': '"\\e90d"',
    'video-mute': '"\\e90e"',
    'video-pause': '"\\e90f"',
    'video-play': '"\\e910"',
    'video-sound': '"\\e911"',
    whatsapp: '"\\e915"',
    youtube: '"\\e922"',
    'efteling-logo': '"\\e927"',
    'category-fallback': '"\\e927"',
    'category-attraction': '"\\e928"',
    'category-restaurant': '"\\e929"',
    'category-show': '"\\e92a"',
    'category-theater': '"\\e92a"',
    'category-merchandise': '"\\e92b"',
    'category-fairytale': '"\\e92c"',
    'category-facilities-toilets': '"\\e92d"',
    'category-overnight': '"\\e937"',
    'category-domain': '"\\e937"',
    expand: '"\\e935"',
    close: '"\\e936"',
};

export default icons;
